var map = {
	"./accounts/accounts-routes.js": 57823,
	"./administrator/administrator-routes.js": 63373,
	"./application-status/application-status-routes.js": 68961,
	"./application-type/application-type-routes.js": 34377,
	"./applications/applications-routes.js": 73457,
	"./archive/archive-routes.js": 44677,
	"./atlas/atlas-routes.js": 15425,
	"./auth/auth-routes.js": 45691,
	"./beneficiaries/beneficiaries-routes.js": 82993,
	"./complain-type/complain-type-routes.js": 99021,
	"./complain/complain-routes.js": 1593,
	"./control-type/control-type-routes.js": 32855,
	"./control/control-routes.js": 88317,
	"./dashboard/dashboard-routes.js": 88249,
	"./decision-purpose/decision-purpose-routes.js": 43705,
	"./decision-target/decision-target-routes.js": 7569,
	"./document-series-allocation/document-series-allocation-routes.js": 40511,
	"./document-series-type/document-series-type-routes.js": 54999,
	"./document-template/document-template-routes.js": 97,
	"./efactura/efactura-routes.js": 58721,
	"./forms/forms-routes.js": 65849,
	"./home/home-routes.js": 64593,
	"./internal-documents/internal-documents-routes.js": 23927,
	"./issued-document/issued-document-routes.js": 77973,
	"./layout/layout-routes.js": 93561,
	"./metadata-mapping/metadata-mapping-routes.js": 42151,
	"./notifications/notifications-routes.js": 69039,
	"./payment-registry/payment-registry-routes.js": 78359,
	"./permissions/permissions-routes.js": 39513,
	"./process-editor/process-editor-routes.js": 13657,
	"./profile/profile-routes.js": 81013,
	"./real-estate-register/real-estate-register-routes.js": 30353,
	"./registers-type/registers-type-routes.js": 2753,
	"./registers/registers-routes.js": 92433,
	"./response-templates/response-templates-routes.js": 71229,
	"./responsibilities/responsibilities-routes.js": 55427,
	"./system-settings/system-settings-routes.js": 24345,
	"./tax-category/tax-category-routes.js": 62639,
	"./translations/translations-routes.js": 6299,
	"./useful-links/useful-links-routes.js": 77083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63564;